import { render, staticRenderFns } from "./ProjetoDetalhamento.vue?vue&type=template&id=687b515e&"
import script from "./ProjetoDetalhamento.vue?vue&type=script&lang=js&"
export * from "./ProjetoDetalhamento.vue?vue&type=script&lang=js&"
import style0 from "./ProjetoDetalhamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports